export const addIdToRoute = (route: string, id: string) => {
  if (route.includes('/:id')) {
    return route.replace('/:id', `?id=${id}`)
  }
  return route + `?id=${id}`
}
